import React, { useState } from "react";
import axios from "axios";
import { getServiceNameWithNickname } from "../../../../../utils/getServiceNameWithNickname";
import CashFlowProfitDetailsList from "./CashFlowProfitDetailsList";
import { parseAxiosError } from "../../../../../utils/response";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import { useTranslation } from "react-i18next";

import { StyledAboutOfProfit, StyledCashFlowProfitListItem } from "../styledCashFlowProfit";
import { StyledCol, StyledTableRow } from "../../../../styles/styledTable";

const CashFlowProfitDetailsContainer = ({ service, filterData }) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_ITEMS_PER_PAGE = 1000;

  const [showDetails, setShowDetails] = useState(false);
  const [profitDetails, setProfitDetails] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  let url = `&service=${service.name}&currency=${service.asset}&paymentSystem=${service.subName}${filterData.dateFrom ? `&dateFrom=${filterData.dateFrom}` : ""}${filterData.dateTo ? `&dateTo=${filterData.dateTo}` : ""}`;
  let clientDetailsUrl = `&${filterData.dateFrom ? `&dateFrom=${filterData.dateFrom}` : ""}${filterData.dateTo ? `&dateTo=${filterData.dateTo}` : ""}`;

  const showProfitDetails = () => {
    setShowDetails(!showDetails);

    if (!showDetails) {
      fetchProfitDetails();
    }
  };

  const fetchProfitDetails = () => {
    axios.get("/api/get-profit?byClient=1" + url + "&itemsPerPage=" + DEFAULT_ITEMS_PER_PAGE, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setProfitDetails(response.data["profits"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <StyledCashFlowProfitListItem>
      <StyledTableRow
        onClick={() => showProfitDetails()}
        col="4"
        scroll="auto"
        cursor="pointer"
        className={`profit-list-table__row ${showDetails ? "active" : ""}`}
      >
        <StyledCol data-title={t("profit.table.service")}>
          {getServiceNameWithNickname(service.name, service.nickname)}
        </StyledCol>
        <StyledCol data-title={t("profit.table.paymentSystem")}>
          {service.subName}
        </StyledCol>
        <StyledCol data-title={t("profit.table.currency")}>
          {service.asset}
        </StyledCol>
        <StyledCol data-title={t("profit.table.profit")} inline>
          <StyledAboutOfProfit color={service.profit > 0 ? "green" : service.profit < 0 ? "red" : "transparent"}>
            {service.profit} {service.asset}
          </StyledAboutOfProfit>
        </StyledCol>
      </StyledTableRow>
      {showDetails && <CashFlowProfitDetailsList url={clientDetailsUrl} profitDetails={profitDetails} />}
    </StyledCashFlowProfitListItem>
  );
};

export default CashFlowProfitDetailsContainer;